/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent, useRef, useState, useCallback } from 'react'

import { colors } from 'shared/styles/colors'
import { validateTypeFile } from 'shared/utils/validates'

import SizedBox from '../SizedBox'
import Text from '../Text'
import { IButtonFileComponentProps } from './ButtonFileComponent.types'
import { StyledButtonFile, Button } from './styles'

const ButtonFile: FunctionComponent<IButtonFileComponentProps> = ({
  id,
  onSelectFile,
  file,
  className,
  colorFileText,
  accept,
  label,
}) => {
  const inputFileRef = useRef<HTMLInputElement>(null)
  const [nameFile, setNameFile] = useState(file)
  const [hasUnsupportedExtension, setHasUnsupportedExtension] = useState(false)

  const handleChangeFile = useCallback(
    e => {
      if (
        inputFileRef.current?.files &&
        inputFileRef.current.files[0] &&
        inputFileRef.current.files[0].name
      ) {
        onSelectFile(e.target.files[0], inputFileRef.current.files[0].name)

        setNameFile(inputFileRef.current.files[0].name)
        setHasUnsupportedExtension(
          !validateTypeFile(inputFileRef.current.files[0].name),
        )
      }
    },
    [onSelectFile, setNameFile],
  )

  return (
    <>
      <StyledButtonFile
        ref={inputFileRef}
        type="file"
        id={id}
        onChange={handleChangeFile}
        accept={accept}
      />
      <Button htmlFor={id} className={className}>
        {label}
      </Button>
      <SizedBox />
      {nameFile && !hasUnsupportedExtension && (
        <Text
          color={colorFileText || colors.gray4}
          weight="bold"
          fontStyle="italic"
        >
          {nameFile}
        </Text>
      )}

      {nameFile && hasUnsupportedExtension && (
        <>
          <Text color={colors.red} weight="bold" fontStyle="italic">
            {nameFile}
          </Text>
          <Text color={colors.red} weight="bold" fontStyle="italic">
            `Formato inválido, inserir arquivos: ${accept}`
          </Text>
        </>
      )}

      {!nameFile && !hasUnsupportedExtension && (
        <Text color={colorFileText ?? colors.white}>
          `Aceita arquivos: ${accept}`
        </Text>
      )}
    </>
  )
}

export default ButtonFile
